import React from 'react';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { CONTACT } from '../data/media';
import { Mascot } from './Mascot';
import { Reveal } from './Reveal';
export function CtaBanner() {
  const {
    t
  } = useLanguage();
  return <section className="w-full py-16 lg:py-20" style={{
    background: 'linear-gradient(135deg, #FF8C42 0%, #FFD700 100%)'
  }} data-id="element-96" data-mp="ynf4o423giyw">
      <div className="mx-auto flex max-w-shell flex-col items-center gap-10 px-4 text-center sm:px-6 lg:flex-row lg:justify-between lg:px-8 lg:text-left" data-id="element-97" data-mp="1wa5k6apmrzfs">
        <Reveal className="max-w-2xl" data-id="element-98" data-mp="1mbycyjl58vqz">
          <h2 className="font-display text-3xl font-extrabold leading-[1.1] text-ink sm:text-4xl lg:text-[48px]" data-id="element-99" data-mp="1mawrdl6i4qv0">
            {t.cta.title}
          </h2>
          <p className="mt-4 text-base font-semibold text-ink/75 sm:text-lg" data-id="element-100" data-mp="axuasq4ek1au">{t.cta.sub}</p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center lg:justify-start" data-id="element-101" data-mp="5yhny5dj6u89">
            <a href={`tel:+1${CONTACT.phoneRaw}`} className="inline-flex items-center justify-center gap-2 rounded bg-ink px-7 py-4 font-display text-sm font-extrabold uppercase tracking-wide text-white transition-colors duration-200 ease-smooth hover:bg-charcoal" data-id="element-102" data-mp="1b92ih3ttvprf">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-103" data-mp="1696kbl7tasjs" />
              {t.cta.call}
            </a>
            <a href="#contact" className="group inline-flex items-center justify-center gap-2 rounded border-2 border-ink bg-white px-7 py-4 font-display text-sm font-extrabold uppercase tracking-wide text-ink transition-colors duration-200 ease-smooth hover:bg-ink hover:text-white" data-id="element-104" data-mp="si1ge6xeve3n">
              {t.cta.quote}
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-105" data-mp="ngvno93r3qu4" />
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.08} className="shrink-0" data-id="element-106" data-mp="2g87m5nki3x6o">
          <Mascot size={180} tone="light" animate className="shadow-lift" data-id="element-107" data-mp="2g9sjtm243w8r" />
        </Reveal>
      </div>
    </section>;
}